import React, {useContext, useEffect, useRef, useState} from 'react';
import { Field } from 'react-final-form';
import Grid from "@material-ui/core/Grid";
import i18n, { Trans } from "../utils/i18n";
import {hasProducts} from "../config/orderEntryEnfore";
import {useFormState, useFormStateDispatch} from "../FormComponents/FormState";
import {Button, IconButton, Modal} from "@mui/material";
import {InputLabel, Typography} from "@material-ui/core";
import styled from "styled-components";
import RadioButton from "./RadioBig";
import FormControl from "@material-ui/core/FormControl";
import DeleteIcon from "@material-ui/icons/Delete";
import CloseIcon from "@material-ui/icons/Close";
import { flatten } from "lodash";
import TextInput from "./TextInput";
import classNames from "classnames";
import TextField from "@mui/material/TextField";
import map from "lodash/map";
import MuiSelect from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import { useGetProductCategories } from '../hooks/useOrderProductCategories';



const ProductRow = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    margin: 15px 0;
    align-items: center;
`;

const ProductColumn = styled.div`
    flex: 1;
    display: flex;
    align-items: center;

    @media (min-width: 768px) {
        gap: 1.5rem;
    }
`;

const ProductColumn2 = styled.div`
    width: 20%;
    display: flex;
    min-width: 8rem;
`;

const ProductCategory = styled.div`
    font-size: 14px;
`;

const ProductName = styled.div`
    font-weight: bold;
`;

const Image = styled.img`
    max-width: 100%;
    height: 60px;
    object-fit: contain;
    display: none;

    @media (min-width: 768px) {
        display: block;
    }
`;

export const ModalContent = styled.div`
    background-color: white;
    width: 100%;
    max-width: 70rem;
    max-height: 100vh;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    position: relative;
    outline: none;
    flex-wrap: wrap;
    padding: 3rem;
    overflow-y: scroll;

    @media (min-width: 768px) {
        margin-top: 20vh;
        width: 90%;
        max-height: calc(100vh - 25%);
    }
`;

export const ProductSelectDynamic = React.memo(function ({ values, mode, form, productValues, amountOptions, }) {
        const orderEntryDispatch = useFormStateDispatch();
        const [modalOpen, setModalOpen] = useState(false);
        const [selectedCategory, setSelectedCategory] = useState(null);
        const productsRef = useRef();
        const products = values.products ?? [];
        const queryResponse = useGetProductCategories({ requesttype: values.requesttype }, {
            onSuccess: (response) => {
                orderEntryDispatch({
                    type: "setCategories",
                    value: response.categories,
                });
            }
        });
        const categories = queryResponse?.data?.categories || [];
        const productsFromState = flatten(map(categories, 'products'));

        if (!categories) {
            return <div><Trans i18nKey="productSelect.loading">Loading</Trans></div>;
        }

        const selectAmount = (amountOptions || [...Array(999).keys()].map(number => ({
            value: String(number + 1),
            label: String(number + 1),
        })));

        return (
            <div>
                <Grid container spacing={3} alignItems={'center'}>
                    <Grid item xs={12} sm={8}>
                        <h3
                            style={{
                                fontSize: 14,
                            }}>
                            <Trans i18nKey="orderEntry.productSelection">Product selection</Trans>
                        </h3>
                        <p>
                            <Trans i18nKey="orderEntry.productSelection.description"></Trans>
                        </p>
                    </Grid>
                    <Grid container item xs={12} sm={4} f justifyContent={'flex-end'} >
                        <Button
                            onClick={() => {
                                setModalOpen(true);
                            }}
                            variant="contained"
                        >
                            <Trans i18nKey="orderEntry.addProduct">Add product</Trans>
                        </Button>
                    </Grid>
                </Grid>
                {
                    products.length > 0 && (
                        <hr style={{ marginBottom: 30 }}/>
                    )
                }
                <Grid container spacing={3}>
                    {
                        modalOpen &&
                        <Modal
                            open={true}
                            onClose={() => {
                                setModalOpen(false);
                            }}
                        >
                            <ModalContent>
                                <IconButton aria-label="delete" onClick={() => {
                                    setModalOpen(false);
                                }}
                                style={{
                                    position: 'absolute',
                                    top: '1.5rem',
                                    right: '1.5rem',
                                }}>
                                    <CloseIcon />
                                </IconButton>
                                <div>
                                    <Typography variant="h5" style={{ marginBottom: 30, fontSize: 22 }}><Trans i18nKey="orderEntry.productSelect.selectCategory">Please select a category</Trans></Typography>
                                    <Grid container spacing={3}>
                                        {
                                            categories
                                                .map((category) =>
                                                    <Grid item xs={12} sm={4} key={category.id}>
                                                        <RadioButton
                                                            input={{
                                                                checked: selectedCategory?.id === category.id,
                                                                value: category.id,
                                                                onChange: (e) => {
                                                                    setSelectedCategory(category);
                                                                    productsRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start', alignToTop: true });
                                                                },
                                                            }}
                                                            field={{
                                                                titel: category.name,
                                                            }}
                                                            meta={{}}
                                                        />
                                                    </Grid>,
                                                )
                                        }
                                    </Grid>
                                    <Typography variant="h5" style={{ marginTop: 30, fontSize: 22 }}><Trans i18nKey="orderEntry.productSelect.heading">Please select your product</Trans></Typography>
                                    <Grid container spacing={3} style={{ marginTop: 30}} ref={productsRef}>
                                        {
                                            selectedCategory && selectedCategory.products.map((item) =>
                                                    <Grid item xs={12} sm={4} key={item.id}>
                                                        <RadioButton
                                                            input={{
                                                                name: 'product',
                                                                type: 'radio',
                                                                value: item.id,
                                                                onChange: (e) => {
                                                                    setModalOpen(false);
                                                                    setSelectedCategory(null);
                                                                    if(mode !== 'serialnumber' && products.find((product) => product.id === item.id)) {
                                                                        if(amountOptions) {
                                                                            return;
                                                                        }
                                                                        form.change(`products`, products.map(item => ({
                                                                            ...item,
                                                                            amount: Number(item.amount) + 1,
                                                                        })));
                                                                        return;
                                                                    }
                                                                    form.change(`products`, [...products, {
                                                                        id: item.id,
                                                                        amount: amountOptions ? Number(amountOptions[0].value) : 1,
                                                                        serialnumber: '',
                                                                        terminalId: '',
                                                                        uuid: Math.random(0, 100000000),
                                                                    }]);
                                                                },
                                                            }}
                                                            field={{
                                                                titel: item.description,
                                                                image: item.image,
                                                            }}
                                                            meta={{}}
                                                        />
                                                    </Grid>,
                                                )
                                        }
                                    </Grid>
                                </div>
                            </ModalContent>
                        </Modal>
                    }
                </Grid>
                <div>
                    {
                        products?.map((item) => {
                            const resolvedItem = productsFromState.find(product => product.id === item.id);
                            return (
                                <div className={'grid gap-6 grid-cols-12 my-3'} key={item.uuid}>
                                    <div className={classNames('col-span-10 flex md:gap-3', {
                                        'md:col-span-4': mode === 'serialnumber',
                                        'md:col-span-9': mode !== 'serialnumber',
                                    })}>
                                        {
                                            resolvedItem?.image && <div>
                                                <Image src={resolvedItem.image} alt={resolvedItem.description}/>
                                            </div>
                                        }
                                        <div>
                                            <ProductCategory> {categories.find(category => category.id === resolvedItem?.productcategory_id)?.name}</ProductCategory>
                                            <ProductName>{resolvedItem?.description}</ProductName>
                                        </div>
                                    </div>
                                    <div
                                        className={classNames('col-span-2 md:col-span-1 flex md:gap-3 border-b-3 border-gray-500 sm:border-b-0')}>
                                        <IconButton aria-label="delete" onClick={() => {
                                            form.change(`products`, products.filter((product, roundIndex) => product.uuid !== item.uuid));
                                        }}>
                                            <DeleteIcon/>
                                        </IconButton>
                                    </div>
                                    {
                                        mode !== 'serialnumber' && (
                                            <div className={classNames('col-span-12 flex md:gap-3 border-b-3 border-gray-500 sm:border-b-0 md:col-span-2')}>
                                                <FormControl variant={"outlined"}>
                                                    <InputLabel htmlFor={'select_product_amount'}>
                                                        <Trans i18nKey="common.amount"> Amount </Trans> *
                                                    </InputLabel>
                                                    <MuiSelect
                                                        id={'select_product_amount' }
                                                        native
                                                        label={i18n.t('common.amount')+' *'}
                                                        onChange={(event) => {
                                                            form.change(`products`, products.map(product => product.id === item.id ?
                                                                {...product, amount: Number(event.target.value),}
                                                                :
                                                                product));
                                                        }}
                                                        value={item.amount}
                                                    >
                                                        {
                                                            selectAmount.map((item, index) => (
                                                                <option key={index} value={item.value}>{item.label}</option>
                                                            ))
                                                        }
                                                    </MuiSelect>
                                                </FormControl>
                                            </div>
                                        )
                                    }
                                    {
                                        mode === 'serialnumber' && (
                                            <>
                                                <div
                                                    className={classNames('col-span-12 flex md:gap-3 border-b-3 border-gray-500 sm:border-b-0', {
                                                        'md:col-span-4': mode === 'serialnumber',
                                                        'md:col-span-3': mode !== 'serialnumber',
                                                    })}>
                                                    <TextField
                                                        type={'text'}
                                                        label={<Trans i18nKey="common.serialNumber"> Serialnumber </Trans>}
                                                        value={item.serialnumber}
                                                        onChange={(event) => {
                                                            form.change(`products`, products.map((product) => product.uuid === item.uuid ?
                                                                {...product, serialnumber: event.target.value,}
                                                                :
                                                                product));
                                                        }}
                                                    />
                                                </div>
                                                <div
                                                    className={classNames('col-span-12 flex md:gap-3 border-b-3 border-gray-500 sm:border-b-0 md:col-span-3')}>
                                                    <TextField
                                                        type={'text'}
                                                        label={<Trans i18nKey="orderEntry.terminalId.label">Terminal ID</Trans>}
                                                        value={item.terminalId}
                                                        onChange={(event) => {
                                                            form.change(`products`, products.map((product) => product.uuid === item.uuid ?
                                                                {...product, terminalId: event.target.value,}
                                                                :
                                                                product));
                                                        }}
                                                    />
                                                </div>
                                            </>
                                        )
                                    }
                                </div>
                            );
                        })
                    }
                </div>
            </div>
        );
    },
    function areEqual(prevProps, nextProps) {
        return JSON.stringify(prevProps) === JSON.stringify(nextProps);
    });

